import { render, staticRenderFns } from "./FoivSelector.vue?vue&type=template&id=12bd3e36&"
import script from "./FoivSelector.vue?vue&type=script&lang=js&"
export * from "./FoivSelector.vue?vue&type=script&lang=js&"
import style0 from "./FoivSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports